import type { SupportedColorScheme, Theme } from '@mui/material'
import invariant from 'tiny-invariant'

export const getGuitarColors = ({
  theme,
  colorScheme = 'light',
}: {
  theme: Theme
  colorScheme?: SupportedColorScheme
}) => {
  const colors = theme.colorSchemes[colorScheme]
  invariant(colors, 'Color scheme ${colorScheme} not found')

  return {
    /** Constants */
    labelStyle: colors.palette.text.primary,
    labelText: colors.palette.background.default,
    muteStyle: colors.palette.action.active,
    outlineStyle: colors.palette.divider,
    watermarkStyle: colors.palette.text.secondary,
    nutStyle: colors.palette.action.disabled,
    fretStyle: colors.palette.text.primary,
    inlayStyle: colors.palette.action.disabled,
    stringStyle: colors.palette.text.secondary,
    fingeringStyle: theme.notes?.[colorScheme].main,
    fingeringStyleInScale: theme.notes?.[colorScheme].inScale,
    fingeringStyleOutOfScale: theme.notes?.[colorScheme].outOfScale,
    fingeringStyleRoot: theme.notes?.[colorScheme].root,
  }
}
